// Código do produto (22/09/2026): o MESMO campo `products.barcode` guarda um
// código de barras (GTIN) ou um código próprio da loja ("CESTA-01"). A regra
// de normalização vive aqui porque vale nos 3 lugares — cadastro, servidor e
// bipe do PDV — e o produto só é encontrado se os 3 gravarem/compararem igual.
//
// - Só dígitos com 8, 12, 13 ou 14 posições = código de barras → 14 dígitos
//   com zeros à esquerda (forma canônica GS1, igual a antes; a consulta na
//   internet e a duplicidade entre leitores de 12 e 13 dígitos dependem disso).
// - Qualquer outra coisa = código próprio → maiúsculas, sem espaços; letras,
//   números, hífen, ponto e barra; 2 a 30 caracteres.
// Motivação: Bruna Flores e Cestas (Ultra) queria criar o próprio código por
// produto e recebia "Código de barras inválido." — o campo apagava as letras.

export const CODIGO_PRODUTO_MAX = 30;

const PROPRIO_RE = /^[A-Z0-9][A-Z0-9.\-\/]{1,29}$/;

/** true se o valor (já limpo) é um GTIN: só dígitos, 8/12/13/14 posições. */
export function ehCodigoDeBarras(v: string): boolean {
  return /^\d+$/.test(v) && [8, 12, 13, 14].includes(v.length);
}

/** Limpa o que o lojista digitou sem decidir nada: maiúsculas, sem espaços. */
export function limparCodigoProduto(v: unknown): string {
  return String(v ?? "").toUpperCase().replace(/\s+/g, "").slice(0, CODIGO_PRODUTO_MAX);
}

/**
 * O que gravar/comparar. GTIN vira 14 dígitos; código próprio fica como está
 * (limpo). Devolve null pra vazio e pra código próprio fora do formato — o
 * chamador decide se isso é "limpar" (vazio) ou "inválido" (recusar).
 */
export function normalizarCodigoProduto(v: unknown): string | null {
  const s = limparCodigoProduto(v);
  if (!s) return null;
  if (ehCodigoDeBarras(s)) return s.padStart(14, "0");
  return PROPRIO_RE.test(s) ? s : null;
}

/** Vazio é permitido; preenchido tem que normalizar. */
export function codigoProdutoValido(v: unknown): boolean {
  const s = limparCodigoProduto(v);
  return !s || normalizarCodigoProduto(s) !== null;
}

/** Guardado → forma de mostrar: GTIN sem zeros extras, código próprio como está. */
export function formatarCodigoProduto(guardado: string | null | undefined): string {
  const c = String(guardado ?? "");
  if (!/^\d{14}$/.test(c)) return c;
  if (c.startsWith("000000")) return c.slice(6);
  if (c.startsWith("00")) return c.slice(2);
  if (c.startsWith("0")) return c.slice(1);
  return c;
}
